// generated from 54 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const attributedSourceFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("attributed_source_filter"),
  comparison_key: z.enum([
    "1", // 48 (88.89%)
    "11", // 3 (5.56%)
    "12", // 2 (3.70%)
    "2", // 1 (1.85%)
    // Constants::Comparisons.matches_and_existence (AttributedSourceFilter#allowed_comparisons)
    "10",
    "17",
  ]),
  display_name: z.string(),
  // undefined: 9 (16.67%), defined 45 (83.33%)
  // null for a blank comparison (11/12) once allow_nil_blank_filters is on: stored as nil
  // (Filter.enforce_nil_for_blank_comparison) and echoed as raw_value via Filter#get_raw_value
  raw_value: z.string().nullable().optional(),
  value: z.string().nullable(),
  varies_by_app_group: z.literal(true),
});
